import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { FoodTypeAdapter } from './dto/food-type.adapter';
import { FoodTypesController } from './food-types.controller';
import { FoodType } from './food-types.entitiy';
import { FoodTypesService } from './food-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([FoodType]),
  ],
  controllers: [FoodTypesController],
  providers: [FoodTypesService,FoodTypeAdapter,ApplicationExceptionHandler,LogsService],
  exports: [FoodTypesService],

})
export class FoodTypesModule {}
